import { FC, useEffect, useState } from 'react';
import { Alert, Button } from 'antd';
import { useMethods } from '@lhb/hook';
import { userPermissionList } from '@/common/api/permission';
import { getChancePointDetail } from '@/common/api/expandStore/chancepoint';
import RelationCheckSpotTasksModal from '@/views/expandstore/pages/chancepoint/components/RelationCheckSpotTasksModal';

interface Props {
  id: number;
  name: string;
  missingFlow: boolean;
  missingBrands: boolean;
  shared: boolean;
  onChanged: () => void;
}

/** 分享页只读；仅已有旧关联权限的用户可从报告进入关联管理。 */
const CheckSpotTaskReportHint: FC<Props> = ({ id, name, missingFlow, missingBrands, shared, onChanged }) => {
  const [allowed, setAllowed] = useState(false);
  const [linkedIds, setLinkedIds] = useState<number[]>();
  const [visible, setVisible] = useState(false);
  const methods = useMethods({
    open() { setVisible(true); },
    close() { setVisible(false); },
    changed() { setVisible(false); setLinkedIds(undefined); onChanged(); },
  });
  useEffect(() => {
    let active = true;
    setAllowed(false);
    setLinkedIds(undefined);
    setVisible(false);
    if (shared || (!missingFlow && !missingBrands)) return;
    userPermissionList().then((permissions) => {
      if (!active) return;
      setAllowed(Array.isArray(permissions) && permissions.some(item => item.enCode === 'standardChancePoint:relationPlaceSpot'));
    }).catch(() => { /* 权限查询失败不开放写入口。 */ });
    getChancePointDetail({ id }).then((detail) => {
      if (!active) return;
      if (Array.isArray(detail?.checkSpotTaskIds)) setLinkedIds(detail.checkSpotTaskIds);
      else if (detail?.checkSpotTaskIds === null) setLinkedIds([]);
    }).catch(() => { /* 读取失败不误报为无关联。 */ });
    return () => { active = false; };
  }, [id, shared, missingFlow, missingBrands]);
  if (shared || (!missingFlow && !missingBrands)) return null;
  const modules = [missingFlow && '客流信息', missingBrands && '周边临近品牌'].filter(Boolean).join('、');
  return <>
    <Alert type='info' showIcon message={`${modules}暂无数据`}
      description={linkedIds === undefined ? '关联踩点任务并完成现场采集后，可查看对应报告数据。' : linkedIds.length > 0 ? `已关联 ${linkedIds.length} 个任务，等待对应采集数据回传。` : '尚未关联踩点任务。'}
      action={allowed && linkedIds !== undefined ? <Button onClick={methods.open}>去关联踩点任务</Button> : undefined} />
    {visible && allowed && linkedIds !== undefined && <RelationCheckSpotTasksModal record={{ id, name, checkSpotTaskIds: linkedIds }} onCancel={methods.close} onSuccess={methods.changed} />}
  </>;
};

export default CheckSpotTaskReportHint;
